import { createSelector } from 'reselect'
import { getCanViewLuxPlusBenefits, getIsFreePreviewLuxPlusMember, getIsExpiredLuxPlusMemberInGracePeriod } from './featureToggle'

export const getActiveOrRenewingLuxPlusSubscriptionId = createSelector(
  (state: App.State) => state.auth.account.luxPlus.member.subscription.item,
  (subscription): string | undefined => {
    if (subscription?.status !== 'ACTIVE' && subscription?.status !== 'AWAITING_RENEWAL') return undefined

    return subscription.id
  },
)

export const getHasPaidLuxPlusMembershipInCurrentRegion = createSelector(
  (state: App.State) => getCanViewLuxPlusBenefits(state),
  (state: App.State) => getIsFreePreviewLuxPlusMember(state),
  (canViewLuxPlusBenefits, isFreePreviewLuxPlusMember): boolean =>
    canViewLuxPlusBenefits && !isFreePreviewLuxPlusMember,
)

/**
 * Whether the account-drawer LuxPlus+ tile should present the member state rather than the
 * "join" prompt. A membership that is still recoverable — active, awaiting renewal, or expired
 * but within its grace window — counts as a member here; only a fully-lapsed (past-grace) or
 * never-subscribed account sees the join prompt.
 *
 * Deliberately broader than getCanRedeemLuxPlusBenefits, which gates actual benefit redemption
 * and excludes awaiting-renewal ("benefits on hold"). This is display classification only.
 */
export const getIsLuxPlusMemberOrWithinGrace = (state: App.State): boolean =>
  getHasPaidLuxPlusMembershipInCurrentRegion(state) || getIsExpiredLuxPlusMemberInGracePeriod(state)
